import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";

//STYLES
import * as SectionsStyles from "./styles/sections";

//COMPONENTS
import PageNavigationButtons from "../navBar/pageNavigationButtons";
import ContentSection from "./contentSection";

function Community(props) {
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);

    const [mobileSubNavBarShow, setMobileSubNavBarShow] = useState(false);

    const [subNavBarSelection, setSubNavBarSelection] = useState(0);

    const [pageID, setPageID] = useState(8);

    useEffect(() => {
        const pageUUID = pagesUUIDs.find((page) => page.section == 0).uuid;
        setPageID(pageUUID);
    }, []);

    const pagesUUIDs = [
        { section: 0, uuid: 9 },
        { section: 1, uuid: 10 }
    ];

    function navBarSectionChange(section) {
        setSubNavBarSelection(section);
        const pageUUID = pagesUUIDs.find((page) => page.section == section).uuid;
        setPageID(pageUUID);
    }

    const browserSubNavBar = (
        <Row>
            <Col
                style={subNavBarSelection == 0 ? SectionsStyles.subNavBarLinksSelected : SectionsStyles.subNavBarLinks}
                onClick={navBarSectionChange.bind(this, 0)}
            >
                Groups
            </Col>
            <Col
                style={subNavBarSelection == 1 ? SectionsStyles.subNavBarLinksSelected : SectionsStyles.subNavBarLinks}
                onClick={navBarSectionChange.bind(this, 1)}
            >
                Room Hire
            </Col>
        </Row>
    );

    function toggleMobileMenu() {
        if (!mobileSubNavBarShow) {
            setMobileSubNavBarShow(true);
        } else {
            setMobileSubNavBarShow(false);
        }
    }

    function mobileSectionClick(section) {
        setMobileSubNavBarShow(false);
        setSubNavBarSelection(section);
        const pageUUID = pagesUUIDs.find((page) => page.section == section).uuid;
        setPageID(pageUUID);
    }

    const mobileSubNavBar = (
        <div>
            <div style={SectionsStyles.topNavBar}>
                <div style={SectionsStyles.topBar}>
                    <div style={SectionsStyles.topBarIcon} onClick={toggleMobileMenu}>
                        <i className="fa-solid fa-bars fa-2xl"></i>
                    </div>
                    {mobileSubNavBarShow && (
                        <div style={SectionsStyles.mobileNav_navBody}>
                            <div
                                style={
                                    subNavBarSelection == 0
                                        ? { ...SectionsStyles.mobileNav_navButtonSelected, borderRadius: "0 25px 0 0" }
                                        : { ...SectionsStyles.mobileNav_navButton, borderRadius: "0 25px 0 0" }
                                }
                                onClick={mobileSectionClick.bind(this, 0)}
                            >
                                Groups
                            </div>
                            <div
                                style={
                                    subNavBarSelection == 1
                                        ? { ...SectionsStyles.mobileNav_navButtonSelected, borderRadius: "0 0 25px 0" }
                                        : { ...SectionsStyles.mobileNav_navButton, borderRadius: "0 0 25px 0" }
                                }
                                onClick={mobileSectionClick.bind(this, 1)}
                            >
                                Room Hire
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <div style={{ ...SectionsStyles.backgroundPicture, backgroundImage: `url('/content/mainStyle/sectionsBackgrounds/${props.image}')` }}>
            <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_blueBackground : SectionsStyles.blueBackground}>
                <PageNavigationButtons upText={"Services and Events"} downText={"Links"} />
                <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_insideContainer : SectionsStyles.insideContainer}>
                    <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_whiteCentredSection : SectionsStyles.whileCentredSection}>
                        {GS_generalSettings.isMobile ? mobileSubNavBar : browserSubNavBar}
                        <div style={SectionsStyles.contentContianer}>
                            <ContentSection pageID={pageID} nav={"community"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Community;
